export default "__VITE_ASSET__B0rOXN86__"